export const APP_NAME = 'membership_shell'

export const SURVICATE_KEY = '_sva'

export const SurvicateEvents = {
  SURVICATE_READY: 'SurvicateReady'
}
